import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./firebase.config";

const firebaseInitAuth = () => {
  return initializeApp(firebaseConfig);
};

export default firebaseInitAuth;
